import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/language";
import { Phone, Mail, MessageCircle } from "lucide-react";
import profileImage from "@/assets/images/profile.jpg";

export function AgentProfile() {
  const { t, dir } = useLanguage();

  return (
    <section id="agent" className="py-12 md:py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-8 md:mb-12">
            <div className="inline-block mb-4">
              <div className="h-1 w-16 bg-primary mx-auto mb-4 rounded-full"></div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              {t("meetYourAgent")}
            </h2>
            <p className="text-base md:text-xl text-muted-foreground max-w-2xl mx-auto">
              {t("agentIntro")}
            </p>
          </div>

          {/* Agent Card */}
          <div className="bg-background rounded-2xl p-6 md:p-10 shadow-lg border border-border">
            <div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-10">
              {/* Profile Image */}
              <div className="flex-shrink-0">
                <div className="relative">
                  <img
                    src={profileImage}
                    alt={t("agentName")}
                    className="w-48 h-48 md:w-64 md:h-64 object-cover rounded-full border-4 border-primary shadow-lg"
                    style={{ transform: dir === "rtl" ? "scaleX(-1)" : "none" }}
                  />
                  <div className="absolute -bottom-2 -right-2 bg-primary text-primary-foreground rounded-full p-3 shadow-lg">
                    <Phone size={24} />
                  </div>
                </div>
              </div>

              {/* Agent Info */}
              <div className="flex-1 text-center md:text-start" dir={dir}>
                <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
                  {t("agentName")}
                </h3>
                <p className="text-lg md:text-xl text-primary font-medium mb-4">
                  {t("agentTitle")}
                </p>
                <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-6">
                  {t("agentDescription")}
                </p>

                {/* Contact Info */}
                <div className="space-y-3 mb-6" dir={dir}>
                  <div className="flex items-center justify-center md:justify-start space-x-3 text-sm md:text-base">
                    <Phone size={18} className="text-primary" />
                    <a
                      href="tel:+972502364585"
                      className="hover:text-primary transition-colors"
                      dir="ltr"
                    >
                      +972-50-236-4585
                    </a>
                  </div>
                  <div className="flex items-center justify-center md:justify-start space-x-3 text-sm md:text-base">
                    <Mail size={18} className="text-primary" />
                    <a
                      href="mailto:samantha@realestate-in-israel.com"
                      className="hover:text-primary transition-colors truncate"
                    >
                      samantha@realestate-in-israel.com
                    </a>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 justify-center md:justify-start">
                  <Button
                    asChild
                    size="lg"
                    className="bg-primary hover:bg-primary/90"
                  >
                    <a href="tel:+972502364585">
                      <Phone size={18} className="mr-2" />
                      {t("callNow")}
                    </a>
                  </Button>
                  <Button asChild variant="outline" size="lg">
                    <a
                      href="https://wa.me/972502364585"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <MessageCircle size={18} className="mr-2" />
                      {t("whatsapp")}
                    </a>
                  </Button>
                  <Button asChild variant="outline" size="lg">
                    <a href="mailto:samantha@realestate-in-israel.com">
                      <Mail size={18} className="mr-2" />
                      {t("sendEmail")}
                    </a>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
